module.exports = __webpack_public_path__ + "static/media/computer.13e55497.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/badges/computer.svg
 ** module id = 122
 ** module chunks = 0
 **/